import React, {PureComponent, ReactNode} from "react"
import gql from "graphql-tag"
import {Query} from "react-apollo"

import {Query as QueryComponent, pagination} from "@irati/utils/services/apollo"
import {ApolloState} from "@irati/utils/services/apollo/apolloStateInterface"

import {AccountRecognitionList} from "@irati/types"
import RecognitionFragment from "../fragments/Recognition"

const query = gql`
  query AccountRecognitions($limit: Int, $cursor: String, $to: String, $from: String) {
    accountRecognitions(limit: $limit, cursor: $cursor, to: $to, from: $from) {
      results {
        ...Recognition
      }
      count
      cursor
    }
  }

  ${RecognitionFragment}
`

export interface AccountRecognitionsVariables {
  limit: number
  to?: string
  from?: string
}

export interface AccountRecognitionsData {
  data: {
    accountRecognitions: AccountRecognitionList
  }
}

interface Props {
  variables?: AccountRecognitionsVariables
  children(state: ApolloState): ReactNode
}

const variables = {
  limit: 5,
  to: undefined,
  from: undefined
}

export const accountRecognitionsQuery = {
  query,
  variables
}

class TypedQuery extends Query<AccountRecognitionsData, AccountRecognitionsVariables> {}

export default class AccountRecognitionsQuery extends PureComponent<Props> {
  static defaultProps = {
    variables
  }

  render() {
    return (
      <QueryComponent
        {...this.props}
        query={query}
        QueryComponent={TypedQuery}
        notifyOnNetworkStatusChange
        useError={false}
        useLoader={false}>
        {(apolloState: ApolloState) => {
          const fetchMore = (vars: AccountRecognitionsVariables) =>
            pagination(
              {
                ...accountRecognitionsQuery,
                variables: vars
              },
              apolloState
            )
          return this.props.children({...apolloState, fetchMore})
        }}
      </QueryComponent>
    )
  }
}
